var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "popper",
    {
      ref: "inventoryBox",
      staticClass: "plep",
      attrs: {
        trigger: "clickToOpen",
        options: {
          placement: "top",
          modifiers: { offset: { offset: "0,10px" } },
        },
      },
      on: {
        show: function ($event) {
          return _vm.getData()
        },
      },
    },
    [
      _c("div", { staticClass: "popper" }, [
        _c("h3", [_vm._v("Manage inventory")]),
        _c("br"),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.selected,
                expression: "selected",
              },
            ],
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.selected = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
            },
          },
          _vm._l(_vm.inventory, function (option, index) {
            return _c(
              "option",
              {
                key: index,
                attrs: { disabled: option.id == 0, "data-stock": option.stock },
                domProps: { value: option.id },
              },
              [_vm._v(" " + _vm._s(option.text) + " ")]
            )
          }),
          0
        ),
        _c("label", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.autoInventory,
                expression: "autoInventory",
              },
            ],
            attrs: { disabled: _vm.disableAutoInventory, type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.autoInventory)
                ? _vm._i(_vm.autoInventory, null) > -1
                : _vm.autoInventory,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.autoInventory,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.autoInventory = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.autoInventory = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.autoInventory = $$c
                }
              },
            },
          }),
          _vm._v("Disable Auto Web Inventory for Product"),
        ]),
        _c("br"),
        _c(
          "button",
          { staticClass: "saveBtn", on: { click: _vm.updateStock } },
          [_vm._v("Save")]
        ),
      ]),
      _c(
        "button",
        {
          staticClass: "invBtn",
          attrs: { slot: "reference" },
          slot: "reference",
        },
        [
          _c(
            "svg",
            {
              staticClass: "fontAwesomeIcon",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 512 512",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z",
                },
              }),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }